import { PhotoManagerPhotoUploadResponse, PhotoManagerPlugin, UploadPhotosOptions } from '../interfaces/photoManager';
import getPlugins from './getPlugins';

export const publisherId = 'com.hp.jarvis.photo.manager.plugin';
export const photoUploadCompleteEvent = 'imageUploadCompleted';

export interface PhotoUploadCompleteEventInfo {
  localPhotoIdentifier: string;
  error?: string;
}

export const photoManagerUpload = async (url: string, photoManagerPhotoIds: string[], userToken: string) => {
  const { PhotoManager } = await getPlugins();

  console.log(`Uploading ${photoManagerPhotoIds.length} photos`);

  const options: UploadPhotosOptions = {
    url: url,
    authToken: userToken,
    photosIds: photoManagerPhotoIds,
    photoIds: photoManagerPhotoIds,
    asMultipartFormData: false,
  };

  // upload all photos
  console.log(PhotoManager, options);
  try {
    console.time('PhotoManager.uploadPhotos');
    const response = await (PhotoManager as PhotoManagerPlugin).uploadPhotos(options);
    console.timeEnd('PhotoManager.uploadPhotos');

    console.log(`PhotoManager.photoUpload contains ${response.result.length} results`);
    console.log('PhotoManager.photoUpload response', response);

    // if ((result as EventServicePluginError).errorType !== undefined) {
    //   console.error('events::createPublisher: %o', result);
    //   throw new Error(`Unable to create publisher`);
    // }
    return response as PhotoManagerPhotoUploadResponse;
  } catch (error) {
    console.error('Error', error);
    throw error;
  }
};

export const cancelPhotoManagerUpload = async () => {
  const { PhotoManager } = await getPlugins();

  console.time('PhotoManager.cancelPhotoUpload');
  await (PhotoManager as PhotoManagerPlugin).cancelPhotoUpload();
  console.timeEnd('PhotoManager.cancelPhotoUpload');
};
